import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  assetTagsList: {},
};

const tagsSlice = createSlice({
  name: "tagsSlice",
  initialState,
  reducers: {
    addAssetTags: (state, action) => {
      state.assetTagsList = action.payload;
    },
    removeAssetTags: (state, action) => {
      state.assetTagsList = {};
    },
  },
});

export const { addAssetTags, removeAssetTags } = tagsSlice.actions;
export default tagsSlice.reducer;
